function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { CloseButton, ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { QBOSetupStep } from "./QBOSetupStep";
import { useEventReporter } from "../../event-reporter";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { useSwitchBusiness } from "../../hooks/useSwitchBusiness";
import { selectors } from "../../store/state-selectors";
import { useStore, useStoreActions, useStoreStatic } from "../../store/store-context";
import { VobQboState } from "../../types/api.model";
import { FirstStep } from "./FirstStep";
import { QBOStep } from "./QBOStep";
import { SavingStep } from "./SavingStep";
import { SecondStep } from "./SecondStep";
import styles from "./VendorOnboardingModal.module.scss";
import { ErrorType, Step } from "./VendorOnboardingModal.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function VendorOnboardingModal(props) {
  const {
    dismissModal,
    vobQboState,
    showQboStep
  } = props;
  const {
    getState
  } = useStoreStatic();
  const workspaces = useStore(selectors.user.workspaces);
  const {
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const {
    switchBusiness
  } = useSwitchBusiness();
  const {
    reportToHeap,
    reportToHubspot,
    reportToAppcues,
    sendEventToGtm
  } = useEventReporter();
  const {
    BUSINESS_DESCRIPTION_ONBOARDING
  } = useFeatureFlags();
  const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
  const [step, setStep] = useState(vobQboState === VobQboState.Started ? Step.QBO : vobQboState === VobQboState.ConnectionTriggered && isLinkedToQbo ? Step.QBOSetup : Step.First);
  const shouldShowCloseButton = step !== Step.QBO && step !== Step.QBOSetup && workspaces && workspaces.some(workspace => workspace.isCompletelySetup());
  const [vobData, setVobData] = useState(() => {
    var _userInfo$business, _userInfo$firstName, _userInfo$lastName, _userInfo$businessNam;
    const {
      userInfo
    } = getState();
    const postalAddress = userInfo === null || userInfo === void 0 || (_userInfo$business = userInfo.business()) === null || _userInfo$business === void 0 ? void 0 : _userInfo$business.postalAddress;
    return {
      name: {
        first: (_userInfo$firstName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.firstName()) !== null && _userInfo$firstName !== void 0 ? _userInfo$firstName : '',
        last: (_userInfo$lastName = userInfo === null || userInfo === void 0 ? void 0 : userInfo.lastName()) !== null && _userInfo$lastName !== void 0 ? _userInfo$lastName : ''
      },
      companyName: (_userInfo$businessNam = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessName()) !== null && _userInfo$businessNam !== void 0 ? _userInfo$businessNam : '',
      postalAddress: {
        address1: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.addressOne) || '',
        address2: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.addressTwo) || '',
        city: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.city) || '',
        state: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.state) || '',
        postalCode: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.postalCode) || '',
        country: (postalAddress === null || postalAddress === void 0 ? void 0 : postalAddress.country) || 'US'
      },
      phone: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone()) || '',
      businessTypes: []
    };
  });
  const onClose = value => {
    reportToAppcues('form-success', 'first_login');
    dismissModal(value);
  };
  async function onXClose() {
    logBI(18103);
    reportToHeap('preliminary-onboarding', 'click', 'user-click-quit-vendor-onboarding');
    const shouldSwitchToOtherBusiness = await overlayContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(ConfirmationModal, {
          title: "Are you sure?",
          content: /*#__PURE__*/_jsx(Typography, {
            children: "Once you quit the Service Provider onboarding process, you will be redirected to your existing account."
          }),
          primaryButtonLabel: "Quit onboarding process",
          onPrimaryButtonClick: () => {
            logBI(18104);
            reportToHeap('preliminary-onboarding', 'click', 'user-click-quit-vendor-onboarding-approve');
            reportToHubspot('create_vendor_account_canceled_v3');
            dismissModal(true);
          },
          secondaryButtonLabel: "Cancel",
          onSecondaryButtonClick: () => dismissModal(false),
          onCloseButtonClick: () => dismissModal(false),
          testId: "quit-confirmation"
        });
      }
    });
    const firstValidWorkspace = workspaces && workspaces.find(workspace => workspace.isCompletelySetup());
    if (shouldSwitchToOtherBusiness && firstValidWorkspace) {
      await switchBusiness(firstValidWorkspace.id());
      dismissModal(true);
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "vendor-onboarding-modal",
    className: styles.root,
    children: [shouldShowCloseButton && /*#__PURE__*/_jsx(CloseButton, {
      className: styles.closeBtn,
      skin: "transparent",
      testId: "close-btn",
      onClick: onXClose
    }), step === Step.First ? /*#__PURE__*/_jsx(FirstStep, {
      initialState: vobData,
      onSubmit: formData => {
        var _formData$name, _formData$name2, _formData$numOfInvoic;
        const biLogData = _objectSpread(_objectSpread({
          firstName: (_formData$name = formData.name) === null || _formData$name === void 0 ? void 0 : _formData$name.first,
          lastName: (_formData$name2 = formData.name) === null || _formData$name2 === void 0 ? void 0 : _formData$name2.last,
          companyName: formData.companyName,
          businessType: formData.businessTypes
        }, BUSINESS_DESCRIPTION_ONBOARDING && {
          businessDescription: formData.businessDescription
        }), {}, {
          numOfInvoices: formData.numOfInvoices
        });
        logBI(10325, biLogData);
        sendEventToGtm('onboarding_business_details', {
          company_name: formData.companyName,
          company_services: BUSINESS_DESCRIPTION_ONBOARDING ? formData.businessDescription || formData.businessTypes.join(', ') : formData.businessTypes.join(', '),
          monthly_invoices: parseInt((_formData$numOfInvoic = formData.numOfInvoices) !== null && _formData$numOfInvoic !== void 0 ? _formData$numOfInvoic : '0', 10)
        });
        const newFormData = _objectSpread(_objectSpread({}, vobData), formData);
        setVobData(newFormData);
        setStep(Step.Second);
      }
    }) : null, step === Step.Second ? /*#__PURE__*/_jsx(SecondStep, {
      initialState: vobData,
      onSubmit: formData => {
        var _vobData$name$first, _vobData$name, _vobData$name$last, _vobData$name2, _getState$userInfo$em, _getState$userInfo;
        logBI(10326, formData);
        sendEventToGtm('onboarding_business_address', {
          company_city: formData.postalAddress.city,
          company_state: formData.postalAddress.state,
          company_zipcode: parseInt(formData.postalAddress.postalCode, 10),
          phone: formData.phone,
          first_name: (_vobData$name$first = (_vobData$name = vobData.name) === null || _vobData$name === void 0 ? void 0 : _vobData$name.first) !== null && _vobData$name$first !== void 0 ? _vobData$name$first : '',
          last_name: (_vobData$name$last = (_vobData$name2 = vobData.name) === null || _vobData$name2 === void 0 ? void 0 : _vobData$name2.last) !== null && _vobData$name$last !== void 0 ? _vobData$name$last : '',
          email: (_getState$userInfo$em = (_getState$userInfo = getState().userInfo) === null || _getState$userInfo === void 0 ? void 0 : _getState$userInfo.email()) !== null && _getState$userInfo$em !== void 0 ? _getState$userInfo$em : ''
        });
        const newFormData = _objectSpread(_objectSpread({}, vobData), formData);
        setVobData(newFormData);
        setStep(Step.Saving);
      }
    }) : null, step === Step.Saving ? /*#__PURE__*/_jsx(SavingStep, {
      vobData: vobData,
      onSavingSuccess: showQboStep ? () => setStep(Step.QBO) : onClose,
      onErrorBackButton: errorType => {
        if (errorType === ErrorType.General) {
          setStep(Step.First);
        } else {
          setStep(Step.Second);
        }
      }
    }) : null, step === Step.QBO ? /*#__PURE__*/_jsx(QBOStep, {
      onCancel: onClose,
      vobQboState: vobQboState
    }) : null, step === Step.QBOSetup ? /*#__PURE__*/_jsx(QBOSetupStep, {
      onContinue: onClose
    }) : null]
  });
}